import React from 'react';

import { IProduction } from 'interfaces/production';

import formatDate from 'date-fns/format';

import { getLogo } from 'helpers/common';

import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';

import PrintIcon from '@material-ui/icons/PrintOutlined';

import Print from 'components/Common/Print';

import { useStyles } from './styles';

interface IProps {
  order: IProduction;
  disabled?: boolean;
}

export default function Receipt(props: IProps): JSX.Element {
  const { order, disabled } = props;
  const {
    order_code,
    order_type,
    status,
    quantity,
    date_ordered,
    item,
    measure
  } = order;
  const classes = useStyles();

  return (
    <Print
      trigger={
        <Button size="medium" disabled={disabled}>
          <PrintIcon />
        </Button>
      }
      fonts={[]}
      documentTitle={order_code}
    >
      <Card>
        <Grid
          container
          justifyContent="center"
          className={classes.receiptHeader}
        >
          <Grid>
            <img src={getLogo()} alt="Logo" width="250" height="100" />
            <Typography variant="h6">{order_code?.toUpperCase()}</Typography>
            <Typography style={{ marginBottom: 10 }}>
              {formatDate(new Date(date_ordered), 'dd/MM/yyyy - hh:mm')}
            </Typography>

            <Typography variant="h6">TIPO</Typography>
            <Typography style={{ marginBottom: 10 }}>
              {order_type === 'Product' ? 'Produto' : 'Ingrediente'}
            </Typography>

            <Typography variant="h6">STATUS</Typography>
            <Typography style={{ marginBottom: 10 }}>{status}</Typography>

            <Typography variant="h6">
              {order_type === 'Product' ? 'PRODUTO' : 'INGREDIENTE'}
            </Typography>
            <Typography>{`${quantity}${measure || 'x'} ${item}`}</Typography>
          </Grid>
        </Grid>
      </Card>
    </Print>
  );
}

Receipt.defaultProps = {
  disabled: false
};
